import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/what-is-sugargoo-spreadsheet/page";
import ShippingCostPage from "../pages/article/sugargoo-shipping-cost/page";
import CouponGuidePage from "../pages/article/sugargoo-coupon-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/what-is-sugargoo-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/article/sugargoo-shipping-cost",
    element: <ShippingCostPage />,
  },
  {
    path: "/article/sugargoo-coupon-guide",
    element: <CouponGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;